import React from "react";

interface ConstructionTableFixedCellProps {
  value: string;
}

const renderYesNoWhenValueTrueOrFalse = (value: string): string => {
  if (value.toUpperCase() === "TRUE") return "Yes";
  if (value.toUpperCase() === "FALSE") return "No";

  return value;
};

const ConstructionTableFixedCell: React.FunctionComponent<ConstructionTableFixedCellProps> = ({value}) => {
  return <>{renderYesNoWhenValueTrueOrFalse(value)}</>;
};

export default ConstructionTableFixedCell;
